import { render, staticRenderFns } from "./vip8-3.vue?vue&type=template&id=19214c71&scoped=true&"
import script from "./vip8-3.vue?vue&type=script&lang=ts&"
export * from "./vip8-3.vue?vue&type=script&lang=ts&"
import style0 from "./vip8-3.vue?vue&type=style&index=0&id=19214c71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19214c71",
  null
  
)

export default component.exports